import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import orderStatusList from './orderStatusList';
import { useStylesTabs, useStylesTab } from './styles';

const OrderStatusTabs = props => {
  const classesTabs = useStylesTabs();
  const classesTab = useStylesTab();

  return (
    <Tabs
      {...props}
      variant="scrollable"
      scrollButtons="on"
      classes={classesTabs}
      TabIndicatorProps={{ children: <span /> }}
    >
      {orderStatusList.map(orderStatus => (
        <Tab
          key={orderStatus.label}
          label={orderStatus.label}
          value={orderStatus.value}
          classes={classesTab}
        />
      ))}
    </Tabs>
  );
};

export default OrderStatusTabs;
